export const getReportGenerationBugId = () => {
  return {
    id: 503,
    name: 'Report generation',
  };
};
export const getExportReportBugId = () => {
  return {
    id: 504,
    name: 'Export report',
  };
};
